export function createToast(toastClass: string, typeClass: string, headingText: string, message: string): HTMLElement {
    let toast = document.createElement("div");
    toast.classList.add(toastClass);
    toast.classList.add(typeClass);
    toast.dataset.controller = "toast";
    toast.appendChild(newHeading(headingText));
    toast.appendChild(newBody(message));
    return toast;
}

function newHeading(content: string) {
    let heading = document.createElement("h3");
    heading.innerHTML = content;
    return heading;
}

function newBody(content: string) {
    let body = document.createElement("div");
    body.innerHTML = content;
    return body;
}